import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "nk-searchbar__dropdown" }
const _hoisted_2 = ["innerHTML", "onMousedown"]
const _hoisted_3 = {
  key: 0,
  class: "nk-searchbar__dropdown__error"
}

import { ref, watch } from 'vue';
	import { DataType } from '@/core/components/forms/SearchBar/searchBar.shared';
	import { props as propsDefinition } from './searchBar-dropdown.shared';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'NkSearchBarDropdown',
  props: propsDefinition,
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props

	
	

	const itemList = ref<HTMLElement|null>(null);

	const onClick = (item: DataType) => {
		emit('click', item);
	};

	watch(() => props.selected, () => {
		const item = itemList.value?.querySelector('.is-selected');
		if (item) {
			item.scrollIntoView({block: 'center', behavior: 'smooth'});
		}
	});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "nk-searchbar__dropdown__content",
      ref_key: "itemList",
      ref: itemList
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["nk-searchbar__dropdown__item", {
					'is-selected': i === props.selected,
				}]),
          innerHTML: item.label,
          key: item.id,
          onMousedown: ($event: any) => (onClick(item))
        }, null, 42, _hoisted_2))
      }), 128)),
      (props.data.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('searchBar.noResult')), 1))
        : _createCommentVNode("", true)
    ], 512)
  ])), [
    [_directive_loading, props.loading]
  ])
}
}

})